"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGrid = exports.DEFAULT_COLUMN_AMOUNT = void 0;
const pdfTheme_1 = require("../pdfTheme");
exports.DEFAULT_COLUMN_AMOUNT = 2;
class DataGrid {
    constructor(entries, columnAmount = exports.DEFAULT_COLUMN_AMOUNT) {
        this.entries = entries;
        this.columnAmount = columnAmount;
    }
    exportContent() {
        const rows = [];
        for (let i = 0; i < this.entries.length; i += this.columnAmount) {
            // We fill this array with empty strings to pad out the table render
            const row = Array(this.columnAmount).fill('');
            for (let j = 0; j < this.columnAmount; j++) {
                const index = i + j;
                if (index < this.entries.length) {
                    const [title, value] = this.entries[index];
                    row[j] = {
                        columnGap: pdfTheme_1.pdfTheme.spacing.default,
                        columns: [
                            {
                                text: `${title}:`,
                                style: ['cellTitle'],
                                width: 'auto'
                            }, {
                                text: value,
                                style: ['cellValue']
                            }
                        ]
                    };
                }
            }
            rows.push(row);
        }
        return {
            layout: 'noBorders',
            table: {
                // If there are no rows, then we need an empty 2d array to successfully render the table
                body: rows.length ? rows : [[]]
            },
            style: ['dataGrid']
        };
    }
    exportStyles() {
        return {
            dataGrid: {
                fontSize: 12,
                marginBottom: pdfTheme_1.DEFAULT_COMPONENT_SPACING,
                marginLeft: pdfTheme_1.DEFAULT_COMPONENT_SPACING,
                marginRight: pdfTheme_1.DEFAULT_COMPONENT_SPACING
            },
            cellTitle: {
                bold: true,
                fontSize: 12
            },
            cellValue: {
                fontSize: 10,
                marginTop: 2
            }
        };
    }
}
exports.DataGrid = DataGrid;
//# sourceMappingURL=DataGrid.js.map